

<script>
import { mapGetters } from 'vuex';

export default {
  name: "CartSummary",

  data() {
    return {
      dots: 3,
      dotsInterval: null,
    };
  },
  watch: {
    submitOrderInProgress(newVal) {
      if (newVal) {
        this.dotsInterval = setInterval(() => {
          this.dots = this.dots >= 10 ? 1 : this.dots + 1;
        }, 500);
      } else {
        clearInterval(this.dotsInterval);
        this.dots = 1;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.dotsInterval);
  },

    computed:{
        ...mapGetters('cart', ['cart', 'isLoadingCart', 'submitOrderInProgress', 'orderSubmited', 'orderFailed']),

      showCartSummary() {
        const draftItems = this.cart?.lines?.draft?.items || [];
        const submittedItems = this.cart?.lines?.submitted?.items || [];
        return draftItems.length > 0 || submittedItems.length > 0;
      },
    },

};
</script>


<template>

  <div>

    <div  v-if="submitOrderInProgress" 
      class="cart-summary-bar d-flex align-items-center shadow-lg p-3 px-3 justify-content-between" >
      <div class="d-flex align-items-center w-100 justify-content-center">
        <span style="font-size: 40px; letter-spacing: 0.3rem;" class="text-primary">
          <span v-for="n in dots" :key="n" class="dot">.</span>
        </span>
      </div>
    </div>


    <div v-else-if="orderSubmited" class="cart-summary-bar d-flex align-items-center shadow-lg p-3 px-3 justify-content-center text-primary" >
      <div class="d-flex align-items-center">
        <img
          src="@/assets/icons/checked.gif"
          height="70"
          class="mr-2"
          alt="Commande envoyée"
          style="vertical-align: middle;"/>

        <span
          class="order-submitted-text text-uppercase fw-bold"
          style="font-size: 18px; letter-spacing: 0.15rem;"
        >
          {{ $t('menuOrder.cart.orderSubmitted') }}
        </span>
      </div>
    </div>

    <div v-else-if="orderFailed" class="cart-summary-bar d-flex align-items-center shadow-lg p-3 px-3 justify-content-center text-danger" >
      <div class="d-flex align-items-center">
        <img
          src="@/assets/icons/error2.gif"
          height="50"
          class="mr-2"
          alt="Échec commande"
          style="vertical-align: middle;"/>
        <span
          class="order-submitted-text text-uppercase fw-bold"
          style="font-size: 18px; letter-spacing: 0.15rem;"
        >
          {{ $t('menuOrder.cart.orderFailed') }}
        </span>
      </div>
    </div>
    
    <div v-else-if="this.showCartSummary" class="cart-summary-bar d-flex align-items-center shadow-lg p-3 px-3" style="justify-content: space-between;">

      <div class="font-weight-bold text-dark font-size-16">
        {{ cart && cart.lines ? cart.lines.cartTotal : '' }}
      </div>

      <b-button @click="$emit('expand')" variant="light" class="btn-pill text-white font-weight-bold font-size-16 checkout-cart-btn position-relative" >
        {{ $t('menuOrder.cart.button.order') }}
        <b-badge
          v-if="cart && cart.lines && cart.lines.draftCountItems"
          variant="danger"
          class="position-absolute rounded-circle font-weight-bold"
          style="top: -5px; right: -8px; font-size: 10px; padding: 0.3rem 0.4rem;"
        >
          {{ cart.lines.draftCountItems }}
        </b-badge>
      </b-button>

    </div>

    </div>
</template>


<style scoped>
.cart-summary-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 0.75rem 1rem;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2) !important;
  z-index: 1000;
  transform: translateZ(0); 
  height: 77px;
}

.checkout-cart-btn {
  border-radius: 25px;
  padding: 0.6rem 1.9rem;
  background: linear-gradient(90deg, #28a745, #218838);
  transition: all 0.2s;
  letter-spacing: 0.1rem;
}


.dot {
  display: inline-block;
  font-weight: bold;
  color: #28a745;
  animation: bounce 1s infinite;
}

.dot:nth-child(1) { animation-delay: 0s; }
.dot:nth-child(2) { animation-delay: 0.2s; }
.dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes bounce {
  0%, 80%, 100% { transform: translateY(0); opacity: 0.6; }
  40% { transform: translateY(-4px); opacity: 1; }
}


.bell-effect {
  display: inline-block;
  transform-origin: top center; /* pivot depuis le haut */
  animation: smooth-ring 1s infinite ease-in-out; /* vitesse doublée */
}

@keyframes smooth-ring {
  0%   { transform: rotate(0deg); }
  10%  { transform: rotate(15deg); }
  20%  { transform: rotate(-10deg); }
  30%  { transform: rotate(12deg); }
  40%  { transform: rotate(-8deg); }
  50%  { transform: rotate(10deg); }
  60%  { transform: rotate(-6deg); }
  70%  { transform: rotate(6deg); }
  80%  { transform: rotate(-4deg); }
  90%  { transform: rotate(2deg); }
  100% { transform: rotate(0deg); }
}

.order-submitted-text {
  /*display: inline-block;*/
  animation: fadeIn 0.8s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}


</style>